import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

import api from './../../service/api';
import { formatDate } from '../../service/format';
import { calculateDateInterval, downloadCsv } from '../../service/handle';

const TireControl = () => {
    let emptyTireControl = {
        truck: '',
        number: null,
        axle: null,
        side: '',
        type: '',
        isnew: 'true',
        kilometer_initial: null,
        kilometer_final: null,
        datecontrol_initial: null,
        datecontrol_final: null
    };


    const types = [
        { label: 'Liso', value: 'flat'},
        { label: 'Borrachudo', value: 'rubbery'}
    ];

    const sides = [
        { label: 'Direito', value: 'left'},
        { label: 'Esquerdo', value: 'right'},
        { label: 'Ambos', value: 'both'},
    ];

    const situations = [
        { label: 'Novo', value: 'true'},
        { label: 'Remoldado', value: 'false'}
    ];

    const [tireControls, setTireControls] = useState([]);
    const [trucks, setTrucks] = useState([]);
    const [truck, setTruck] = useState('all');
    const [filterTruck, setFilterTruck] = useState([{ label: 'Todos', value: 'all' }]);
    const [tireControlDialog, setTireControlDialog] = useState(false);
    const [tireControl, setTireControl] = useState({...emptyTireControl});
    const [submitted, setSubmitted] = useState(false);
    const [deleteTireControlDialog, setDeleteTireControlDialog] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.value) || '';
        let _tireControl = { ...tireControl };
        _tireControl[`${name}`] = val;

        setTireControl(_tireControl);
    }

    const openNew = () => {

        setTireControl({...emptyTireControl});
        setSubmitted(false);
        setDisabled(false);
        setTireControlDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setTireControlDialog(false);
        setDisabled(false);
    }

    const handleTireControl = () => {
        if(!tireControl.truck || !tireControl.axle || !tireControl.kilometer_initial
            || !tireControl.side || !tireControl.type || !tireControl.datecontrol_initial
                || tireControl.axle > 99 )
                return setSubmitted(true);

        setSubmitted(false);
        setDisabled(true);

        var _tireControl = {...tireControl};

        if((tireControl.datecontrol_initial && typeof tireControl.datecontrol_initial === 'object') || false)
            _tireControl.datecontrol_initial = tireControl.datecontrol_initial.getTime();

        if((tireControl.datecontrol_final && typeof tireControl.datecontrol_final === 'object') || false)
            _tireControl.datecontrol_final = tireControl.datecontrol_final.getTime();

        _tireControl.isnew = tireControl.isnew === 'true';

        api().post(!tireControl.code ? '/tirecontrol/create' : '/tirecontrol/update', {..._tireControl}).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listTireControls();
                hideDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        }).catch(error => {
            console.log(error);

            hideDialog();
            toast.current.show({severity: 'warn', summary: 'Atenção', detail: 'Não foi possível realizar a operação, entre em contato com o suporte!'});
        });
    }

    const __enricherTireControl = (tireControl) => {
        tireControl.typeEnrichered = tireControl.type === 'flat' ? 'Liso' : 'Burrachudo';
        tireControl.sideEnrichered = tireControl.side === 'left' ? 'Esquerdo' : (tireControl.side === 'right' ? 'Direito' : 'Ambos');
        tireControl.kilometer_total =
            tireControl.kilometer_final &&
            tireControl.kilometer_initial ?
                (Math.abs( tireControl.kilometer_final - tireControl.kilometer_initial)) : '-';
        tireControl.date_interval = calculateDateInterval(tireControl.datecontrol_initial, tireControl.datecontrol_final);
        return tireControl;
    }

    const listTireControls = (truckSelected = 'all') => {
        setLoading(true);
        var url = truckSelected !== 'all' ? '/tirecontrol/truck/' + truckSelected : '/tirecontrol/list';
        api().get(url).then(response => {
            if(response.status === 200 && response.data.result){
                setTireControls(response.data.data.map(__enricherTireControl));
            }
            setLoading(false);
        });
    }

    const editTireControl = (rowData) => {
        setTireControl(rowData);
        setSubmitted(false);
        setTireControlDialog(true);
        setDisabled(false);
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                var filter = [{ label: 'Todos', value: 'all' }];
                response.data.data.forEach(truck => {
                    filter.push({ label: truck.plate, value: truck.code });
                });
                setFilterTruck(filter);
                setTrucks(response.data.data);
            }
        });
    }

    const handleDeleteTireControl = () => {
        setLoading(true);
        api().delete('/tirecontrol/' + tireControl.code).then(response => {
            setDeleteTireControlDialog(false);
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listTireControls();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Controle de Pneus</h5>
            <div className="field m-0">
                <Dropdown value={truck} id="truckFilter" options={filterTruck} onChange={(e) => {
                    setTruck(e.value);
                    listTireControls(e.value);
                }} optionLabel="label" optionValue='value' placeholder="Selecione um caminhão" />
            </div>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handleTireControl} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions" style={{ whiteSpace: 'nowrap' }}>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info mr-2" onClick={() => editTireControl(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" onClick={() => {
                    setDeleteTireControlDialog(true);
                    setTireControl({...rowData});
                }} />
            </div>
        );
    }

    const hideDeleteTireControlDialog = () => {
        setTireControl({...emptyTireControl});
        setDeleteTireControlDialog(false);
    }

    const deleteTireControlDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteTireControlDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTireControl} />
        </>
    );

    const [loadingExport, setLoadingExport] = useState(false);
    const rightButton = () => (
        <>
            <Button label="Exportar" icon="pi pi-download" loading={loadingExport} className="p-button-text" onClick={() => {
                setLoadingExport(true);
                downloadCsv(['Caminhão', 'Número', 'Eixo', 'Lado', 'Tipo', 'Situação', 'Km (Inicial)', 'Km (Final)',
            'Data (Inicial)', 'Data (Final)', 'Km (Total)', 'Intervalo'], tireControls.map(data => {
                    var dateOptions = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                    }
                    return [
                        (data.plate || '-').toUpperCase(),
                        data.number,
                        data.axle,
                        (data.side === 'left' ? 'Esquerdo' : (data.side === 'right' ? 'Direito' : 'Ambos')),
                        data.type === 'flat' ? 'Liso' : 'Borrachudo',
                        data.isnew ? 'Novo' : 'Remoldado',
                        data.kilometer_initial,
                        data.kilometer_final,
                        data.datecontrol_initial ? new Date(data.datecontrol_initial).toLocaleDateString('pt-br', dateOptions) : '-',
                        data.datecontrol_final ? new Date(data.datecontrol_final).toLocaleDateString('pt-br', dateOptions) : '-',
                        data.kilometer_total,
                        data.date_interval
                    ];
                }), 'Controle_de_pneus_' + Date.now());
                setTimeout(() => {
                    setLoadingExport(false)
                }, 3000);
            }} />
        </>
    );

    useEffect(() => {
        listTireControls();
        listTrucks();
    }, []);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightButton}></Toolbar>

                    <DataTable ref={dt} value={tireControls} loading={loading}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="plate"  header="Caminhão" sortable></Column>
                        <Column field="number" body={rowData => rowData.number || '-'} header="Nº"></Column>
                        <Column field="axle" header="Eixo"></Column>
                        <Column field="sideEnrichered" header="Lado"></Column>
                        <Column field="typeEnrichered" header="Tipo"></Column>
                        <Column field="isnew" body={rowData => rowData.isnew ? 'Novo' : 'Remoldado'} header="Situação"></Column>
                        <Column field="kilometer_initial"  header="Km (Inicial)"></Column>
                        <Column field="kilometer_final"  header="Km (Final)"></Column>
                        <Column field="datecontrol_initial" body={rowData => formatDate(rowData.datecontrol_initial, false)} header="DT (Inicial)"></Column>
                        <Column field="datecontrol_final" body={rowData => rowData.datecontrol_final ? formatDate(rowData.datecontrol_final, false) : '-'} header="DT (Final)"></Column>
                        <Column field="kilometer_total"  header="Km (Total)"></Column>
                        <Column field="date_interval"  header="Intervalo"></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={tireControlDialog} style={{ width: '450px' }} header="Controle de Pneus" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>

                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor="number">Número do Pneu (Opcional)</label>
                                <InputNumber disabled={disabled} autoFocus id="number" value={tireControl.number} mode='decimal' onChange={(e) => onInputChange(e, 'number')} />
                            </div>
                            <div className="field col">
                                <label htmlFor="axle">Eixo</label>
                                <InputNumber disabled={disabled} id="axle" value={tireControl.axle} mode='decimal' onChange={(e) => onInputChange(e, 'axle')} />
                                {submitted && (!tireControl.axle || tireControl.axle > 99) && <small className="p-invalid p-error">Verifique o valor desse campo.</small>}

                            </div>
                        </div>

                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor='side'>Lado</label>
                                <Dropdown value={tireControl.side} id="side" options={sides} onChange={(e) => onInputChange(e, 'side')} optionLabel="label" optionValue='value' placeholder="Selecione um lado" />
                                {submitted && !tireControl.side && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                            </div>

                            <div className="field col">
                                <label htmlFor='type'>Tipo</label>
                                <Dropdown value={tireControl.type} id="type" options={types} onChange={(e) => onInputChange(e, 'type')} optionLabel="label" optionValue='value' placeholder="Selecione um tipo" />
                                {submitted && !tireControl.type && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                            </div>
                        </div>

                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor='situation'>Situação</label>
                                <Dropdown value={tireControl.isnew ? 'true' : 'false'} id="situation" options={situations} onChange={(e) => onInputChange(e, 'isnew')} optionLabel="label" optionValue='value' placeholder="Situação do pneu" />
                            </div>
                            <div className="field col">
                                <label htmlFor='truck'>Caminhão</label>
                                <Dropdown value={tireControl.truck} id="truck" options={trucks} onChange={(e) => onInputChange(e, 'truck')} optionLabel="plate" optionValue='code' placeholder="Selecione o caminhão" />
                                {submitted && !tireControl.truck && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                            </div>
                        </div>
                        <div className="field">
                            <label htmlFor="datecontrol_initial">Data da Troca (Inicial)</label>
                            <Calendar id="datecontrol_initial" disabled={disabled} dateFormat="dd/mm/yy" locale='pt-br' value={tireControl.datecontrol_initial ? new Date(tireControl.datecontrol_initial) : null} onChange={(e) => onInputChange(e, 'datecontrol_initial')} showIcon />
                            {submitted && !tireControl.datecontrol_initial && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="kilometer_initial">Quilometragem (Inicial)</label>
                                <InputNumber disabled={disabled} id="kilometer_initial" currency='BRL' minFractionDigits={0} mode='decimal' value={tireControl.kilometer_initial} onValueChange={(e) => onInputChange(e, 'kilometer_initial')}  />
                                {submitted && !tireControl.kilometer_initial && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                            </div>
                        </div>

                        {tireControl.code ? (
                            <>
                                <div className="formgrid grid">
                                    <div className="field col">
                                        <label htmlFor="kilometer_final">Quilometragem (Final)</label>
                                        <InputNumber id="kilometer_final" currency='BRL' minFractionDigits={0} mode='decimal' value={tireControl.kilometer_final} onValueChange={(e) => onInputChange(e, 'kilometer_final')}  />
                                        {submitted && !tireControl.kilometer_final && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                                    </div>
                                </div>
                                <div className="formgrid grid">
                                    <div className="field col">
                                        <label htmlFor="datecontrol_final">Data da Troca (Final) </label>
                                        <Calendar id="datecontrol_final" dateFormat="dd/mm/yy" locale='pt-br' value={tireControl.datecontrol_final ? new Date(tireControl.datecontrol_final) : null} onChange={(e) => onInputChange(e, 'datecontrol_final')} showIcon />
                                        {submitted && !tireControl.datecontrol_final && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                                    </div>
                                </div>
                            </>
                        ) : ''}
                    </Dialog>

                    <Dialog visible={deleteTireControlDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteTireControlDialogFooter} onHide={hideDeleteTireControlDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {tireControl && <span>Você tem certeza que deseja remover este registro?</span>}
                        </div>
                    </Dialog>

                </div>
            </div>
        </div>
    );
}

export default TireControl;
